import { put, takeEvery } from "redux-saga/effects";
import { createBrowserHistory } from "history";
import {
  GET_INVOICE_INIT_ACTION,
  GET_INVOICE_SUCCESS_ACTION,
  GET_INVOICE_FAIL_ACTION
} from "./action";
import { push } from "connected-react-router";
import { appConfig } from "../../config";
import "react-toastify/dist/ReactToastify.css";

var history = createBrowserHistory();

function* getInvoices(value) {
  const token = localStorage.getItem("token");
  // const distID = JSON.parse(localStorage.getItem("userDetails")).id;
  const distributorProfId = localStorage.getItem("distributorId");

  let pageno = !value.value
    ? 1
    : value.value.page === undefined
    ? 1
    : value.value.page;
  let filter = !value.value
    ? ""
    : value.value.filter === ""
    ? ""
    : value.value.filter;
  let search = !value.value
    ? ""
    : value.value.search === ""
    ? ""
    : value.value.search;

  try {
    const res = yield fetch(
      `${appConfig.ip}/invoice?invType=chemist&customerId=${distributorProfId}&status=${filter}&search=${search}&limit=10&page=${pageno}&sort=-updatedAt`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }
    );
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();

      yield put({
        type: GET_INVOICE_SUCCESS_ACTION,
        payload: resJSON
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: GET_INVOICE_FAIL_ACTION,
        error: err
      });
    } else {
    }
  }
}

export function* InvoiceActionWatcher() {
  yield takeEvery(GET_INVOICE_INIT_ACTION, getInvoices);
}